import { AVAILABLE_LANGUAGES } from '@/constants';
import { useTranslation } from 'react-i18next';
import { SylndrHelpPoint, SylndrHelpPoints } from './sylndr-help.types';
import Image from 'next/image';
import { ChevronLeft } from 'public/Images';
import Typography from '@/components/shared/typography/typography.component';

export const SylndrHelpSectionDesktop = ({
    lang,
    handleClickOnSection,
}: {
    lang: AVAILABLE_LANGUAGES;
    handleClickOnSection: (section: SylndrHelpPoint) => void;
}) => {
    const { t } = useTranslation();
    const reversedPoints = [...SylndrHelpPoints].reverse();
    return (
        <div>
            <div className="mb-3">
                <Typography className="text-gray-800 text-subtitle2SemiBold">
                    {t('CarProfile.SylndrHelp.title')}
                </Typography>
                <Typography className="text-gray-600 text-body2">
                    {t('CarProfile.SylndrHelp.subTitle')}
                </Typography>
            </div>
            <div className="flex gap-x-2">
                {reversedPoints.map(section => {
                    return (
                        <SylndrHelpContainer
                            key={section.index}
                            section={section}
                            lang={lang}
                            handleClickOnSection={handleClickOnSection}
                        />
                    );
                })}
            </div>
        </div>
    );
};

const SylndrHelpContainer = ({
    section,
    lang,
    handleClickOnSection,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
    handleClickOnSection: (section: SylndrHelpPoint) => void;
}) => {
    return (
        <div
            className="flex-1 p-4 rounded-xl border border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors bg-white"
            onClick={() => handleClickOnSection(section)}
        >
            <div className="flex-shrink-0 mb-3">
                <Image
                    src={section.miniIcon}
                    alt={section.title.en}
                    className="en:transform en:scale-x-[-1]"
                />
            </div>
            <div className="flex items-center gap-1">
                <div className="flex flex-col gap-1 flex-1">
                    <Typography className="text-gray-800 text-body2SemiBold">
                        {section.title[lang]}
                    </Typography>
                    <Typography className="text-caption text-gray-500">
                        {section.subTitle[lang]}
                    </Typography>
                </div>
                <div className="shrink-0">
                    <Image
                        src={ChevronLeft}
                        alt="info"
                        className="flex-shrink-0 en:rotate-180"
                        width={20}
                        height={20}
                    />
                </div>
            </div>
        </div>
    );
};
